import { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import {
  Button,
  Card,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Popup,
  Table,
} from "semantic-ui-react";
import {
  useUserStore,
  ACLType,
  UserType,
  useMetaACLStore,
  MetaACLType,
} from "../store";

const UserEdit = () => {
  const userStore = useUserStore();
  const metaACLStore = useMetaACLStore();
  const history = useHistory();
  const [user, setUser] = useState<UserType>();
  const [metaACLs, setMetaACLs] = useState<MetaACLType[]>();
  const { id } = useParams<{ id: string | undefined }>();
  useEffect(() => {
    metaACLStore.list().then(({ results }) => {
      setMetaACLs(results);
    });
  }, []);
  useEffect(() => {
    userStore.get(parseInt(id || "0")).then((user) => {
      setUser(user);
    });
  }, [id]);
  const groupACLs = (id: number) => {
    return user?.acl_user?.filter((acl) => acl.group === id);
  };
  const permissionACLs = (id: number) => {
    return user?.acl_user?.filter((acl) => acl.permission === id);
  };
  const ACL = (acl: ACLType) => (
    <div>
      {acl?.filtros.map((f) => (
        <Label>
          {metaACLStore.labelACLFilter(metaACLs || [], acl, f.chave)}: &nbsp;
          {metaACLStore.valueACLFilter(metaACLs || [], acl, f.chave, f.valor)}
        </Label>
      ))}
    </div>
  );
  const Confirmation = ({clickHandler, name, title}: {
      clickHandler: () => Promise<void>,
      name: string,
      title: string,
  }) => {
    const [showPopup, setShowPopup] = useState(false)
    return (
      <Popup
        name={`btn-exclui-${name}`}
        title="Excluir"
        trigger={<Icon title={`Excluir ${title}`} name="trash alternate" />}
        on="click"
        onOpen={() => setShowPopup(true)}
        onClose={() => setShowPopup(false)}
        open={showPopup}
      >
        <Popup.Header>Deseja excluir?</Popup.Header>
        <Popup.Content>
          <Button
            name={`btn-cancela-excluir-${name}`}
            onClick={() => setShowPopup(false)}
          >
            Não
          </Button>
          <Button
            name={`btn-confirm-excluir-${name}`}
            onClick={async () => {
              await clickHandler()
              userStore.get(user?.id || 0).then((user) => setUser(user))
            }}
          >
            Sim
          </Button>
        </Popup.Content>
      </Popup>
    );
  }
  return (
    <Card fluid className="card-form">
      <Card.Content>
        <Form>
          <Form.Input label="Usuário:" type="text" value={user?.username} />
          <Form.Input
            label="Primeiro nome:"
            type="text"
            value={user?.first_name}
          />
          <Form.Input
            label="Último nome:"
            type="text"
            value={user?.last_name}
          />
          <Form.Input
            label="Endereço de email:"
            type="text"
            value={user?.email}
          />
          <Form.Checkbox label="Ativo" checked={user?.is_active} />
          <Form.Checkbox label="Membro da equipe" checked={user?.is_staff} />
          <Form.Checkbox
            label="Status de superusuário"
            checked={user?.is_superuser}
          />
          <Grid verticalAlign="middle" columns={2}>
            <Grid.Column>
              <Header size="small">Grupos</Header>
            </Grid.Column>
            <Grid.Column align="right">
              <Button
                onClick={() => history.push(`/auth/users/${id}/groups/0`)}
              >
                Adicionar grupo
              </Button>
            </Grid.Column>
          </Grid>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.Cell>Nome</Table.Cell>
                <Table.Cell>ACLs</Table.Cell>
                <Table.Cell></Table.Cell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {user?.groups?.map((group) => (
                <Table.Row>
                  <Table.Cell>
                    <Link to={`/auth/users/${id}/groups/${group.id}`}>
                      {group.name}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>
                    {groupACLs(group.id)?.map((acl) => ACL(acl))}
                  </Table.Cell>
                  <Table.Cell>
                    <Confirmation
                      title='Grupo'
                      name='group'
                      clickHandler={
                        () => userStore.deleteGroup(user?.id || 0, group.id)
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
          <Grid verticalAlign="middle" columns={2}>
            <Grid.Column>
              <Header size="small">Permissões</Header>
            </Grid.Column>
            <Grid.Column align="right">
              <Button
                onClick={() => history.push(`/auth/users/${id}/permissions/0`)}
              >
                Adicionar permissão
              </Button>
            </Grid.Column>
          </Grid>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.Cell>Nome</Table.Cell>
                <Table.Cell>ACLs</Table.Cell>
                <Table.Cell></Table.Cell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {user?.user_permissions?.map((p) => (
                <Table.Row>
                  <Table.Cell>
                    <Link to={`/auth/users/${id}/permissions/${p.id}`}>
                      {p.name}
                    </Link>
                  </Table.Cell>
                  <Table.Cell>
                    {permissionACLs(p.id)?.map((acl) => ACL(acl))}
                  </Table.Cell>
                  <Table.Cell>
                    <Confirmation
                      title='Permissão'
                      name='permission'
                      clickHandler={async () =>
                        userStore.deletePermission(user?.id || 0, p.id)
                      }
                    />
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Form>
      </Card.Content>
    </Card>
  );
};

export default UserEdit;
